import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Suites from '../views/Suites.vue'
import Alerts from '../views/Alerts.vue'
import Waitlist from '../views/Waitlist.vue'
import Tours from '../views/Tours.vue'
import Login from '../views/Login.vue'
import Properties from '../views/Properties.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Home
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/properties',
    name: 'Properties',
    component: Properties
  },
  {
    path: '/suites/:suiteId',
    name: 'Suites',
    component: Suites
  },
  {
    path: '/suites',
    name: 'Suites',
    component: Suites
  },
  {
    path: '/alerts/:alertId',
    name: 'Alerts',
    component: Alerts
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: Alerts
  },
  {
    path: '/waitlist/:waitlistId',
    name: 'Waitlist',
    component: Waitlist
  },
  {
    path: '/waitlist',
    name: 'Waitlist',
    component: Waitlist
  },
  {
    path: '/tours/:tourId',
    name: 'Tours',
    component: Tours
  },
  {
    path: '/tours',
    name: 'Tours',
    component: Tours
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
